export default __webpack_public_path__ + "static/media/CellFree_Table1.a94dc1dd.png";